import * as mainTerms from '../../mainTerms';
const adFolderDef = mainTerms.Setting.adFolder.default;

const adDef = mainTerms.Setting.ad.default;
const inventoryDef = mainTerms.Setting.inventory.default

export const adFolder = {
    name: {
        label: adFolderDef + ' 이름',
        placeholder: '이름을 입력해주세요',
        error: {
            required: '이름을 입력해주세요',
        },
    },
    upload: {
        label: adDef + ' 업로드',
        column: {
            format: inventoryDef + ' 포맷',
            matchedInventory: '이용 가능한 ' + inventoryDef,
        },
        emptyText: '활성화된 '+inventoryDef+' 포맷이 없습니다.\n'+inventoryDef+' 설정 메뉴에서 설정해주세요'
    }
}